(function() { window.GUID_a3266653_b40b_4e20_841c_077895219518 = { getGuid: function() { return "a3266653-b40b-4e20-841c-077895219518"; } }; })();


//# sourceMappingURL=IPrepareDataToSendGlobal.js.map
